export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_PUBLIC_KEY = import.meta.env
  .VITE_SUPABASE_ANON_PUBLIC_KEY;

export const BASE_URL = document.location.origin;
